
import React, { useState, useRef, useEffect, useMemo } from "react";
import { Card, Bubble, Row, Col } from "tea-component";
import SvgIcon from '@/pages/home/components/SvgIcon';
import CountryTabBreakdown from '@/pages/dashboard/components/CountryRegionRowItem/CountryTabBreakdown';
import CountryTabChartsItem from '@/pages/dashboard/components/CountryRegionRowItem/CountryTabChartsItem';
import { getLocale, useIntl } from "umi";

import "@/pages/dashboard/assets/scss/page/Engagement/components/tableContext.scss";

const CountryRegionRowItem = (props: any) => {
  const {
    regionDataType,
    titleName = '',
    titleContent = undefined,
    responeseValueName = 'value',
    prefix,
    loading,
    titleAndType,
    isSingle,
    isError,
    data,
    timeRange,
    timeType,
    isAllUpper,
    barChartType = 'stackChart',
    isUserQuota = false,
    comConfig = {
      isHaveBar: true,
      isHaveLine: true,
      isHavePie: true,
      isHaveMap: false,
      isHaveEyes: true,
      isHaveShare: true,
      isHaveDiscount: false,
      isHaveStackLine: false,
    },
    unit = '',
    morePie,
    gameCode,
    tableColumns,
    chartTooltipsConfig,
    initActiveIndex,
    downloadFunc,
    showConfig = {
      showTable: true,
      showChart: true,
    },
    customChartOptions,
    shareAndType = '',
    tabOption,
    extraColumn,
    barChartLabelFormatRule,
  } = props;

  const [isShowEyes, setShowEyes] = useState(true);
  const rightCartComRef = useRef<any>(null);
  const { formatMessage } = useIntl();
  const { isHaveBar, isHaveLine, isHavePie, isHaveEyes, isHaveShare, isHaveDiscount, isHaveMap, isHaveStackLine } = comConfig || {};
  const haveNoLineOrBarChart = !isHaveBar && !isHaveLine && !isHaveDiscount && !isHaveStackLine;
  const iconList = [
    { name: 'bar', icon: "column-chart", context: formatMessage({ id: 'common_bar_chart' }), show: isHaveBar },
    { name: 'discount', icon: "discount-chart", context: formatMessage({ id: 'common_line_chart' }), show: isHaveLine },
    { name: 'stackLine', icon: "stack-diagram", context: formatMessage({ id: 'common_stack_line_chart' }), show: isHaveStackLine },
    { name: 'pie', icon: "pie-chart-icon", context: formatMessage({ id: 'common_pie_chart' }), show: isHavePie },
    { name: 'map', icon: "chart-map", context: formatMessage({ id: 'common_map_chart' }), show: isHaveMap },
  ]?.filter(v => v?.show);

  const [icon, setIcon] = useState(iconList?.[initActiveIndex]?.icon || 'column-chart');
  const [activeIndex, setActiveIndex] = useState(initActiveIndex || 0);
  const [mapTooltipName, setMapTooltipName] = useState('');

  useEffect(() => {
    setIcon(iconList?.[initActiveIndex]?.icon || 'column-chart');
    setActiveIndex(initActiveIndex || 0);
  }, [initActiveIndex]);

  useEffect(() => {
    // 修复overview世界地图选中切换tab下标错误
    // 如果不包含该下标icon重置为第一项
    if (!iconList?.[activeIndex]?.icon) {
      setActiveIndex(0);
      setIcon(iconList?.[0]?.icon);
    }
  }, [regionDataType]);

  const isShowDownload = useMemo(() => (haveNoLineOrBarChart ? showConfig?.showTable && showConfig?.showChart && data?.tableData?.length > 0 :
    showConfig?.showTable && showConfig?.showChart && (data?.chartData?.length > 0 || data?.customChartData?.length > 0)), [data, regionDataType, showConfig, haveNoLineOrBarChart, data?.chartData?.length]);

  const titleObj: any = {
    country: formatMessage({ id: 'common_country_top_10' }),
    region: formatMessage({ id: 'common_region_top_10' }),
    network_type: formatMessage({ id: 'common_newtwork_top_10' }),
    zone: formatMessage({ id: 'common_zone_top_10' }),
    os: formatMessage({ id: 'common_platfrom_top_10' }),
    lang: formatMessage({ id: 'common_language_top_10' }),
  };
  const isEn = getLocale() === 'en-US';
  const noTopTitle = regionDataType === 'os' || regionDataType === 'lang';
  const noTitleText = noTopTitle && !isEn ? `${titleObj?.[regionDataType]}${titleName}` : `${titleName} ${titleObj?.[regionDataType]}`;
  const titleText = titleContent ? titleContent?.content : noTitleText;

  return <Card className='register-table dbd-country-region-row-box'>
    <Card.Body title={<div className="page-region-title">{titleText}</div>} operation={
      <div className='register-table-flex'>
        {
          showConfig?.showChart && <div className='register-table-left'>
            {
              isHaveEyes && (data?.chartData?.length > 0 || data?.tableData?.length > 0)  && <Bubble dark content={formatMessage({ id: isShowEyes ? 'common_show_values' : 'common_hide_values' })}>
                <i onClick={() => {
                  setShowEyes(!isShowEyes);
                }}><SvgIcon className='register-table-icon' type={isShowEyes ? 'open-eyes' : 'eyes-closed'} /></i>
              </Bubble>

            }
            {(data?.chartData?.length > 0 || data?.tableData?.length > 0) &&
              iconList.map((e: any, index: number) => <Bubble key={e.icon} dark content={e.context}>
                <i onClick={() => {
                  setIcon(e.icon);
                  setActiveIndex(index);
                }}><SvgIcon className={icon == e.icon ? 'register-table-action' : 'register-table-icon'} type={e.icon} /></i>
              </Bubble>)
            }
          </div>
        }

        {
          isShowDownload && <i onClick={() => {
            downloadFunc ? downloadFunc() : rightCartComRef?.current?.downloadDataFunc();
          }}><SvgIcon className='register-table-icon' type='download' /></i>
        }

      </div>}>
      <Row>
        {
          showConfig?.showTable && <Col>
            <CountryTabBreakdown
              regionDataType={regionDataType}
              tableColumns={tableColumns}
              loading={loading}
              isSingle={isSingle}
              isError={isError}
              data={data?.tableData || []}
              type={titleAndType}
              prefix={prefix}
              isHaveShare={isHaveShare}
              isHaveDiscount={isHaveDiscount}
              isUserQuota={isUserQuota}
              unit={unit}
              gameCode={gameCode}
              shareRename={shareAndType}
              setMapTooltipName={setMapTooltipName}
              tabOption={tabOption}
              extraColumn={extraColumn}
            />
          </Col>
        }
        {
          showConfig?.showChart && <Col>
            <div>
              <CountryTabChartsItem
                ref={rightCartComRef}
                responeseValueName={responeseValueName}
                eyesConfig={
                  {
                    isHaveEyes,
                    isShowEyes
                  }
                }
                data={[data?.chartData || [], data?.tableData || []]}
                chartTooltipsConfig={chartTooltipsConfig}
                mapData={data?.tableData || []}
                comConfig={comConfig}
                timeRange={timeRange}
                activeIndex={activeIndex}
                barChartType={barChartType}
                timeType={timeType}
                isError={isError}
                loading={loading}
                regionDataType={regionDataType}
                type={titleAndType}
                isUserQuota={isUserQuota}
                title={titleContent?.name ? titleContent?.name : noTitleText}
                isAllUpper={isAllUpper}
                unit={unit}
                customChartOptions={customChartOptions}
                gameCode={gameCode}
                morePie={morePie}
                mapTooltipName={mapTooltipName}
                tabOption={tabOption}
                extraColumn={extraColumn}
                barChartLabelFormatRule={barChartLabelFormatRule}
              />
            </div>
          </Col>
        }
      </Row>
    </Card.Body>
  </Card>;
};

export default CountryRegionRowItem;

